/**
 * The v1 server lives in Europe/Moscow (UTC+3, no DST since 2014) and exchanges naive
 * "Y-m-d H:i:s" strings: it ignores any offset we send. Convert at the edge, compute in instants.
 */
const MSK_OFFSET_MS = 3 * 60 * 60 * 1000;
const pad = (n: number) => String(n).padStart(2, '0');

/** Moscow wall clock of an instant, as a Date whose UTC fields hold Moscow time. */
const wall = (d: Date) => new Date(d.getTime() + MSK_OFFSET_MS);
const fromWall = (w: Date) => new Date(w.getTime() - MSK_OFFSET_MS);

export function parseServerDate(value: string | null): Date | null {
  return value ? new Date(`${value.replace(' ', 'T')}+03:00`) : null;
}

export function formatServerDate(d: Date): string {
  const w = wall(d);
  return `${w.getUTCFullYear()}-${pad(w.getUTCMonth() + 1)}-${pad(w.getUTCDate())} ${pad(w.getUTCHours())}:${pad(w.getUTCMinutes())}:${pad(w.getUTCSeconds())}`;
}

/** Start of the Moscow day containing `d`, shifted by `days`. */
export function startOfMoscowDay(d: Date, days = 0): Date {
  const w = wall(d);
  return fromWall(new Date(Date.UTC(w.getUTCFullYear(), w.getUTCMonth(), w.getUTCDate() + days)));
}

/** 23:59:00 Moscow time of the day containing `d` (the server adds :59 seconds itself). */
export function endOfMoscowDay(d: Date, days = 0): Date {
  return new Date(startOfMoscowDay(d, days + 1).getTime() - 60_000);
}

export function moscowTime(d: Date): string {
  const w = wall(d);
  return `${pad(w.getUTCHours())}:${pad(w.getUTCMinutes())}`;
}

export function moscowDayLabel(d: Date, now: Date): string {
  const diff = Math.round((startOfMoscowDay(d).getTime() - startOfMoscowDay(now).getTime()) / 86_400_000);
  if (diff === 0) return 'сегодня';
  if (diff === 1) return 'завтра';
  const w = wall(d);
  return `${pad(w.getUTCDate())}.${pad(w.getUTCMonth() + 1)}`;
}

/** "09.10" in Moscow time. */
export function moscowShortDate(d: Date): string {
  const w = wall(d);
  return `${pad(w.getUTCDate())}.${pad(w.getUTCMonth() + 1)}`;
}
